import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getWalletAction = () => async (dispacth) => {
  dispacth({ type: "GETTING_WALLET" });

  try {
    const { data } = await auction.get("/wallet/read/my-wallet");
    dispacth({
      type: "GETTING_WALLET_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispacth({
      type: "GETTING_WALLET_ERROR",
      payload: error.response ? error.response?.data : error.message,
    });
  }
};

export const getWalletTransactionAction =
  (currentPage, totalNumberRow) => async (dispacth) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispacth({ type: "GETTING_RECENT_TRANSACTION" });
    try {
      const { data } = await auction.get("/wallet/read/my-wallet/transactions");
      dispacth({ type: "GETTING_RECENT_TRANSACTION_SUCCESS", payload: data });
    } catch (error) {
      dispacth({ type: "GETTING_RECENT_TRANSACTION_ERROR" });
    }
  };

export const getWalletWithDrawals = () => async (dispacth) => {
  dispacth({ type: "GETTING_WITHDRAWALS" });
  try {
    const { data } = await auction.get("/wallet/read/my-wallet/withdrawal");
    dispacth({ type: "GOT_WITHDRAWALS", payload: data });
  } catch (error) {
    dispacth({ type: "CANNOT_GET_WITHDRAWALS" });
  }
};

export const getEmdTranscationHistory = () => async (dispacth) => {
  dispacth({ type: "GETTING_EMD_TRANSACTION_HISTORY" });
  try {
    const { data } = await auction.get("/wallet/read/my-wallet/emd-transactions");
    dispacth({ type: "GOT_EMD_TRANSACTION_HISTORY", payload: data });
  } catch (error) {
    dispacth({ type: "CANNOT_GET_EMD_TRANSACTION_HISTORY" });
  }
};

export const getWalletRefundsAction = () => async (dispacth) => {
  dispacth({ type: "GETTING_REFUNDS" });
  try {
    const { data } = await auction.get("/wallet/read/my-wallet/refund-history");
    dispacth({ type: "GOT_REFUNDS", payload: data });
  } catch (error) {
    dispacth({ type: "CANNOT_GET_REFUNDS" });
  }
};

export const getAllBankDetailsAction = () => async (dispacth) => {
  dispacth({ type: "GETTING_BANK_DETAILS" });
  try {
    const { data } = await auction.get("/wallet/read/my-wallet/bank-details");
    dispacth({ type: "GOT_BANK_DETAILS", payload: data });
  } catch (error) {
    dispacth({ type: "CANNOT_GET_BANK_DETAILS" });
  }
};

export const addedBankDetailsAction = (addbankObj) => async (dispatch) => {
  dispatch({ type: "ADD_BANK_LOADING" });
  try {
    const { data } = await auction.put(
      `/profile/update/add-bank-details`,
      addbankObj
    );
    notifySuccess("Account Added Successfully");
    dispatch({ type: "ADD_BANK_LOADED" });
    dispatch({ type: "ADD_BANK_DETAILS", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "ADD_BANK_LOADED" });
  }
};

export const PostAddMoneyToWallect =
  (bankDetail, navigate) => async (dispatch) => {
    dispatch({ type: "SHOW_ADD_MONEY_LOADING" });
    try {
      dispatch({ type: "ADD_MONEY_TOBANK", payload: bankDetail });
      navigate("/wallet/addMoney-details");
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "HODE_ADD_MONEY_LOADDED" });
    }
  };

export const requestToWithdrawAmount = (requestDetails,navigate) => async (dispatch) => {
  dispatch({ type: "REQUEST_WITHDRAWAL_LOADING" });
  try {
    await auction.put(
      `/wallet/update/trader/request-with-drawal`,
      requestDetails
    );
    notifySuccess("Withdrawal request submitted successfully. It will be processed shortly.");
    dispatch({ type: "REQUEST_WITHDRAWAL_SUCCESS" });
    navigate("/wallet")
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "REQUEST_WITHDRAWAL_FEILED" });
  }
};

